<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 18:55:32
-->
<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchPostList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-select v-if="searchShow" v-model="search.hot" clearable placeholder="请选择">
            <el-option label="热门" value="1"></el-option>
            <el-option label="非热门" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchPostList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table v-loading="loading" :data="tableData" size="medium" border>
            <el-table-column
                fixed
                label="序号"
                prop="postId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"  min-width="200" align="left">
            </el-table-column>
            <el-table-column prop="title" label="主题" align="left" min-width="120">
            </el-table-column>
            <el-table-column prop="tolike" label="已解决" width="80">
            </el-table-column>
            <el-table-column prop="dislike" label="未解决" width="80">
            </el-table-column>
            <el-table-column prop="ctime" label="时间" width="180">
            </el-table-column>
            <el-table-column prop="status" label="热门" width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.hot"
                    :active-value="1"
                    :disabled="hotShow"
                    :inactive-value="0"
                    @change="operationSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column width="180" v-if="editShow || deleteShow" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑问题管理"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="650px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item label="图标：">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>
          <el-form-item
              class="item"
              label="名称："
              prop="name"
          >
            <el-input
                clearable
                style="width: 472px"
                placeholder="请填写名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="主题："
          >
            <el-input
                clearable
                style="width: 472px"
                placeholder="请填写主题"
                v-model="params.title"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="摘要："
          >
            <el-input
                clearable
                style="width: 472px"
                :rows="4"
                type="textarea"
                placeholder="请填写摘要"
                v-model="params.abstr"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="排序："
          >
            <el-input
                clearable
                style="width:172px"
                placeholder="请填写排序"
                v-model="params.seq"
            ></el-input>
          </el-form-item>
          <el-form-item class="item" label="内容：">
            <div style="width:470px">
              <richText :keyWord="'detail'" :params="params" v-if="flag"></richText>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";
import richText from "../../components/richText";
import {ossUpload} from "@utils/filters/upload";

export default {
  components: {
    richText
  },
  data() {
    return {
      flag: false,
      PAGE_SIZE,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {
        content:''
      },
      rules: {
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //列表
      srcList:[],
      isMoer:true,

      searchShow: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      hotShow:true
    };
  },
  async created() {
    this.getRoleListTree();
    await this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {
          content:''
        };
        this.srcList = []
        this.flag = false
        this.isMoer = true
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },

    //switch状态改变 --接口 修改管理员状态
    handleSwitch(row) {
      this.$put(`/problem/info/status/${row.problemId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    operationSwitch(row) {
      this.$put(`/problem/info/hot/${row.problemId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    //权限处理
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'basics:problem:query') {
            this.searchShow = true
          }
          if (item.code == 'basics:problem:add') {
            this.addShow = true
          }
          if (item.code == "basics:problem:delete") {
            this.deleteShow = true
          }
          if (item.code == "basics:problem:edit") {
            this.editShow = true
          }
          if (item.code == "basics:problem:status") {
            this.statusShow = false
          }
          if (item.code == "basics:problem:hot") {
            this.hotShow = false
          }
        })
      }
    },
    //筛选
    SearchPostList() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  获取列表
     */
    async getRoleListTree(data, checked) {
      let http = `/problem/list`;
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },
    // 弹窗
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.loading = true;
        const {data: resData} = await this.$get('/problem/info?problemId='+row.problemId);
        this.loading = false;
        // //修改  change
        this.params = resData.data;
        if(resData.data.icon){
          this.srcList.push(resData.data.icon)
          this.isMoer = false
        }else {
          this.srcList = ''
          this.isMoer = true
        }
        this.dialogVisible = true;
        this.flag = true
      } else {
        //添加
        this.params = {
          detail:''
        };
        this.flag = true
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = this.params;
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post("/problem/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              content:''
            };
            this.flag = false
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改岗位
            const {data: resData} = await this.$put(
                "/problem/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              content:''
            };
            this.flag = false
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/problem/info/${row.problemId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },
  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -64px;
  top:0;
}
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    width: auto;
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
